<template>
  <section v-if="isShow">
    <div class="widget" :key="isRender">
      <div
        v-for="channel in chatBar"
        :key="channel.id"
        class="custom-channel"
        @click="showMessages(channel.id)"
      >
        <span class="badge-unread custom-unread" v-show="channel.unreadCount > 0">{{
          channel.unreadCount
        }}</span>
        <div>{{ title(channel) }}</div>
        <div class="custom-desc">{{ description(channel) }}</div>
      </div>
    </div>
  </section>
</template>
<script>
import { mapGetters } from 'vuex'
export default {
  name: 'chat-bar',
  data() {
    return {
      isRender: 0
    }
  },
  mounted() {
    this.$eventBus.$on('chat-refresh-groups', this.refreshBar)
  },
  computed: {
    ...mapGetters('chat', ['chatBar', 'channels']),
    isShow() {
      let _is = false
      if (this.chatBar) {
        if (this.chatBar.length > 0) {
          _is = true
        }
      }
      return _is
    }
  },
  methods: {
    title(channel) {
      let title = ''
      if (channel) {
        if (channel.description) {
          let ro = channel.description.substring(0, channel.description.indexOf(':'))
          title = `# ${channel.id} - ${ro}`
        } else {
          title = `# ${channel.id}`
        }
      }
      return title
    },
    description(channel) {
      let desc = ''
      if (channel) {
        if (channel.description) {
          desc = channel.description.substring(channel.description.indexOf(':') + 1).trim()
        }
      }
      return desc
    },
    refreshBar() {
      let $this = this
      setTimeout(() => {
        console.log('Refreshing Bar', {
          channels: $this.channels,
          chatBar: $this.chatBar
        })
        $this.isRender += 1
        $this.$forceUpdate()
      }, 200)
    },
    showMessages(id) {
      let found = this.channels.find(x => parseInt(x.calibrateEvent) === parseInt(id))
      if (found) {
        this.$emit('showMessages', found)
      }
    }
  }
}
</script>
<style lang="scss" scoped>
.widget {
  margin: 0;
  padding: 0;
  font-size: 100%;
  line-height: 1;
  width: auto;
  height: auto;
  box-sizing: initial;
  z-index: 99991;
  position: absolute;
  right: 80px;
  bottom: 10px;
  width: auto;
  height: 40px;
  text-align: center;
  border-radius: 5px;
  -webkit-box-shadow: 0 1px 6px rgba(0, 0, 0, 0.06), 0 2px 32px rgba(0, 0, 0, 0.16);
  -moz-box-shadow: 0 1px 6px rgba(0, 0, 0, 0.06), 0 2px 32px rgba(0, 0, 0, 0.16);
  box-shadow: 0 1px 6px rgba(0, 0, 0, 0.06), 0 2px 32px rgba(0, 0, 0, 0.16);
  background-color: #19274c;
  display: inline-flex;
  padding-left: 10px;
  padding-right: 10px;
}
.custom-channel {
  background-color: #fff;
  border-radius: 4px;
  margin: 5px;
  padding: 3px;
  font-size: 0.9em;
  min-width: 100px;
}
.custom-desc {
  font-size: 0.7em;
}
.custom-channel:hover {
  cursor: pointer;
  background-color: rgba(255, 255, 255, 0.8);
}
.custom-unread {
  position: absolute;
  right: 18px;
  top: -5px;
}
</style>



// WEBPACK FOOTER //
// src/components/chat/chat-bar.vue